import { html, View, type Html } from 'rune-ts';
import klass from './NViewing.module.scss';
import { classes } from '../../../../shared/util';
import { font } from '../../../../shared/typography';

type NViewingType = 'compact' | 'normal';

export interface NViewingProps {
  n: number;
  klass?: typeof klass;
  type?: NViewingType;
}

export class NViewing extends View<NViewingProps> {
  protected override template(): Html {
    const { type = 'normal' } = this.data;

    return html`
      <div
        class="${classes(klass.n_viewing, {
          [klass.normal]: type === 'normal',
          [klass.compact]: type === 'compact',
          [this.data.klass]: this.data.klass,
        })}"
      >
        <div
          class="${classes(klass.text, {
            [font('12_medium')]: type === 'normal',
            [font('14_medium')]: type === 'compact',
          })}"
        >
          ${html.preventEscape(this._getText())}
        </div>
      </div>
    `;
  }

  private _getText() {
    const { type = 'normal', n } = this.data;

    const TEXT = {
      normal: ET(`product::n_viewing::normal`, { n: n.toLocaleString() }),
      compact: ET(`product::n_viewing::compact`, { n: n.toLocaleString() }),
    };

    return TEXT[type];
  }
}
